import { render, staticRenderFns } from "./totalDealValue.vue?vue&type=template&id=7043ef48"
import script from "./totalDealValue.vue?vue&type=script&lang=js"
export * from "./totalDealValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports